<template>
	<div class="generic-grid-container">
		<h3>Report Properties - TBD</h3>
	</div>
</template>
<script>
export default {
	name: 'ReportProperties',
};
</script>
